<tt-page>
    <div *ngIf="!('mobile' | mediaQuery)" style="display: flex; gap: 0.5rem; height: 100%">
        <ng-container *ngTemplateOutlet="listView"></ng-container>
        <tt-cust-grp2 *ngIf="!!selectedId" [params]="{ custgrp2_keyno: selectedId }" (submit)="onCustGrp2Submit($event)" style="max-width: 40rem"></tt-cust-grp2>
    </div>

    <ng-container *ngIf="'mobile' | mediaQuery" [ngTemplateOutlet]="listView"></ng-container>
</tt-page>

<ng-template #listView>
    <div class="flex-column height-full" style="max-width: 50rem; width: 100%">
        <tt-card>
            <tt-button *ngIf="!('mobile' | mediaQuery)" ttText="new_custgrp2" ttIcon="fas fa-plus" ttIconAlign="left" (ttClick)="selectedId = '0'"></tt-button>
            <tt-button-goto *ngIf="'mobile' | mediaQuery" ttText="new_custgrp2" ttIcon="far fa-plus" ttGoto="custgrp2" [ttGotoParms]="{ custgrp2_keyno: selectedId }"></tt-button-goto>
        </tt-card>
        <tt-list
            class="flex-1"
            ttHeightFull
            #list="radioList"
            ttRadioSelection
            [(ttSelectedId)]="selectedId"
            [ttData]="custgrp2s"
            ttDataId="custgrp_keyno"
            ttDataName="custgrp_name"
            [ttGoto]="'mobile' | mediaQuery"
        ></tt-list>
    </div>
</ng-template>
